import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Basic from '../Components/Basic/Basic';
import Rightside from './Customer/Rightside.js';
import moment from 'moment';
import $ from 'jquery';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const Fum = ({accountSlug:propAccountSlug}) => {
    const navigate = useNavigate();
    const STORAGE_KEY = "caprock-local";
    const systemToken = localStorage.getItem('systemToken') || "";
    const BASE_URL = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
    
    // State variables
    const [userName, setUserName] = useState('');
    const [userInfo, setUserInfo] = useState({});
    const [customerAccounts, setCustomerAccounts] = useState([]);
    const [totalAcBalance, setTotalAcBalance] = useState(0);
    const [totalActiveDefaultBalance, setTotalActiveDefaultBalance] = useState(0);
    const [totalArchiveDefaultBalance, setTotalArchiveDefaultBalance] = useState(0);
    const [defaultCurrencyIcon, setDefaultCurrencyIcon] = useState('$');
    const [defaultCurrency, setDefaultCurrency] = useState('AUD');
    const [subac, setSubac] = useState([
       
    ]);
    const [transactions, setTransactions] = useState([]);
    const [allTransactions, setAllTransactions] = useState([]);
    const [activeSubac, setActiveSubac] = useState(1);
    const [localStorageData, setLocalStorageData] = useState({}); // Renamed from localStorage
    const [activeTab, setActiveTab] = useState('transactions'); // New state for tab management
    const [fees, setFees] = useState([]); // New state for fees data
    const [fum, setFum] = useState({
        ac_balance: 0,
        default_currency_balance: 0,
        userac_name: 'Fund Management',
        userac_reference_code: '#',
        userac_establish_date: ''
    });
    const [allFunds, setAllFunds] = useState([]);
    const [timer, setTimer] = useState(undefined);
    
    // Chart state
    const [last12Months] = useState([
        moment().subtract(11, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(10, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(9, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(8, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(7, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(6, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(5, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(4, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(3, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(2, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(1, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(0, "month").startOf("month").format('MMM, YYYY'),
    ]);
    const [activeChart, setActiveChart] = useState(1);
    const [onChart, setOnChart] = useState(0);
    // const [chart1, setChart1] = useState([0, 0, 0, 0]);
    // const [chart2, setChart2] = useState([0, 0, 0]);
    // const [chart3, setChart3] = useState([0, 0, 0, 0, 0, 0]);
    // const [chart4, setChart4] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    // const [chart5, setChart5] = useState([0, 0]);

    
    const [chart1, setChart1] = useState([1000, 2000, 1500, 3000]);
    const [chart2, setChart2] = useState([2500, 3000, 3500]);
    const [chart3, setChart3] = useState([4000, 4500, 5000, 5500, 6000, 6500]);
    const [chart4, setChart4] = useState([7000, 7500, 8000, 8500, 9000, 9500, 10000, 10500, 11000, 11500, 12000, 12500]);
    const [chart5, setChart5] = useState([13000, 13500]);

    
    // Chart options
  const chartOptions1 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: ["Week 1", "Week 2", "Week 3", "Week 4"],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };

  

  const chartOptions2 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 

  const chartOptions3 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        moment().subtract(5, "month").startOf("month").format('MMM'),
        moment().subtract(4, "month").startOf("month").format('MMM'),
        moment().subtract(3, "month").startOf("month").format('MMM'),
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 
  const chartOptions4 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: last12Months
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };
 

  const chartOptions5 = {
    chart: {
      id: "vuechart-example",
      type: "line",
      height: 180,
      foreColor: '#22b931',
      toolbar: {
        show: false
      },
      stacked: true
    },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return "$" + val.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      },
      min: 0,
      forceNiceScale: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '35%',
        dataLabels: {
          position: 'top',
        },
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return "$" + val;
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#FFF']
      }
    },
    colors: ['#22b931'],
    grid: {
      show: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      },
    },
  };


    const getAccountSlugFromStorage = () => {
        return window.localStorage.getItem('active_page') || 'fum';
    };
    
    // Force crypto for this component - you can make this dynamic later
    const accountSlug = propAccountSlug || 'fum';
    
    // Debug: log what accountSlug is being used
    // console.log('Current accountSlug:', accountSlug);


    const getAccountColors = (slug) => {
        const colorMap = {
          'paymaster': {
            gradient: 'bg-purple-gradient',
            tailwindGradient: 'from-purple-600 to-pink-200',
            bgClass: 'bg-purple-gradient',
            color: '#7957F5',
            colorName: 'purple',
            textColor: 'text-white',
            isDark: false
          },
          'fum': {
            gradient: 'bg-yellow-gradient', 
            tailwindGradient: 'from-orange-400 to-yellow-500',
            bgClass: 'bg-yellow-gradient',
            color: '#fdad41',
            colorName: 'orange',
            textColor: 'text-white',
            isDark: false
          },
          'securities': {
            gradient: 'bg-black-gradient',
            tailwindGradient: 'from-gray-600 to-gray-700',
            bgClass: 'bg-black-gradient',
            color: '#494949',
            colorName: 'black',
            textColor: 'text-white',
            isDark: true
          },
          'property': {
            gradient: 'bg-brown-gradient',
            tailwindGradient: 'from-amber-700 to-amber-800',
            bgClass: 'bg-brown-gradient',
            color: '#ad8e8e',
            colorName: 'brown',
            textColor: 'text-white',
            isDark: false
          },
          'commodities': {
            gradient: 'bg-blue-gradient',
            tailwindGradient: 'from-blue-400 to-blue-500',
            bgClass: 'bg-blue-gradient',
            color: '#33bfff',
            colorName: 'blue',
            textColor: 'text-white',
            isDark: false
          },
          'custodian': {
            gradient: 'bg-dark-gradient',
            tailwindGradient: 'from-gray-900 to-black',
            bgClass: 'bg-dark-gradient',
            color: '#0a0909',
            colorName: 'dark',
            textColor: 'text-white',
            isDark: true
          },
          'my-investment': {
            gradient: 'bg-green-gradient',
            tailwindGradient: 'from-green-500 to-green-400',
            bgClass: 'bg-green-gradient',
            color: '#22b931',
            colorName: 'green',
            textColor: 'text-white',
            isDark: false
          },
          'crypto': {
            gradient: 'bg-crypto',
            tailwindGradient: 'from-indigo-900 to-indigo-950',
            bgClass: 'bg-crypto',
            color: '#08003b',
            colorName: 'black',
            textColor: 'text-white',
            isDark: true
          },
          'private-wealth': {
            gradient: 'bg-crypto',
            tailwindGradient: 'from-indigo-900 to-indigo-950',
            bgClass: 'bg-crypto',
            color: '#08003b',
            colorName: 'black',
            textColor: 'text-white',
            isDark: true
          }
        };
        
        return colorMap[slug] || colorMap['fum']; // Default to crypto colors
      };
      
      const accountColors = getAccountColors(accountSlug);

    // Chart data functions
    const getChartData = (data, labels) => ({
        labels: labels,
        datasets: [{
            label: 'Balance',
            data: data,
            borderColor: '#fdad41',
            backgroundColor: 'rgba(253, 173, 65, 0.1)',
            borderWidth: 2,
            fill: true
        }]
    });

    // Chart data
    const chartData1 = getChartData(chart1, ["Week 1", "Week 2", "Week 3", "Week 4"]);
    const chartData2 = getChartData(chart2, [
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
    ]);
    const chartData3 = getChartData(chart3, [
        moment().subtract(5, "month").startOf("month").format('MMM'),
        moment().subtract(4, "month").startOf("month").format('MMM'),
        moment().subtract(3, "month").startOf("month").format('MMM'),
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
    ]);
    const chartData4 = getChartData(chart4, last12Months);
    const chartData5 = getChartData(chart5, ["0000", "0000"]);

    // API Methods
    const get_user_accounts = async () => {
        try {
            const Base_url = process.env.REACT_APP_BASE_URL || 'https://api.caprock.com.au/';
            console.log('Getting user accounts from:', `${Base_url}api/user-accounts`);
            
            const response = await fetch(`${Base_url}api/user-accounts`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorageData['access-token']}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    token: localStorageData['access-token']
                })
            });
            
            console.log('User accounts response status:', response.status);
            
            if (response.ok) {
                const data = await response.json();
                console.log('User accounts data:', data, "Response is", response);
                if (data.success === 200) {
                    setTotalAcBalance(data.t_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                    setTotalActiveDefaultBalance(0);
                    setTotalArchiveDefaultBalance(0);
                    
                    const acData = data.accounts;
                    let totalActive = 0;
                    let totalArchive = 0;
                    
                    for (let i = 0; i < acData.length; i++) {
                        if (acData[i].userac_status === 1) {
                            totalActive += acData[i].default_currency_balance;
                        } else {
                            totalArchive += acData[i].default_currency_balance;
                        }
                    }
                    
                    setTotalActiveDefaultBalance(totalActive);
                    setTotalArchiveDefaultBalance(totalArchive);
                    
                    // Calculate percentages
                    const accountsWithPercent = acData.map(account => ({
                        ...account,
                        ac_percent: (100 * account.default_currency_balance / totalActive)
                    }));
                    
                    setCustomerAccounts(accountsWithPercent);
                }
            } else {
                console.error('User accounts response not ok:', response.status, response.statusText);
                // Set default values if API fails
                setCustomerAccounts([
                    {
                        userac_id: 1,
                        ac_name: 'Fund Management',
                        ac_slug: 'fum',
                        ac_balance: 10000,
                        default_currency_balance: 10000,
                        userac_status: 1,
                        ac_percent: 100
                    }
                ]);
                setTotalAcBalance('10,000.00');
                setTotalActiveDefaultBalance(10000);
            }
        } catch (error) {
            console.error('Error fetching user accounts:', error);
            // Set default values if API fails
            setCustomerAccounts([
                {
                    userac_id: 1,
                    ac_name: 'Fund Management',
                    ac_slug: 'fum',
                    ac_balance: 10000,
                    default_currency_balance: 10000,
                    userac_status: 1,
                    ac_percent: 100
                }
            ]);
            setTotalAcBalance('10,000.00');
            setTotalActiveDefaultBalance(10000);
        }
    };

    const get_user_info = async () => {
        try {
            const Base_url = process.env.REACT_APP_BASE_URL || 'https://api.caprock.com.au/';
            console.log('Getting user info from:', `${Base_url}api/profile`);
            
            const response = await fetch(`${Base_url}api/profile`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorageData['access-token']}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    token: localStorageData['access-token']
                })
            });
            
            console.log('User info response status:', response.status);
            
            if (response.ok) {
                const data = await response.json();
                console.log('User info data:', data);
                if (data.status === 200) {
                    const userInf = data.profile;
                    userInf.join_date = userInf.join_date ? moment(userInf.join_date).format('DD MMM, YYYY') : '';
                    setUserInfo(userInf);
                    setDefaultCurrency(userInf.default_currency);
                    setDefaultCurrencyIcon(userInf.default_currency_icon);
                }
            } else {
                console.error('User info response not ok:', response.status, response.statusText);
                // Set default values if API fails
                setUserInfo({
                    user_name: 'Demo User',
                    join_date: '01 Jan, 2024',
                    default_currency: 'AUD',
                    default_currency_icon: '$'
                });
                setDefaultCurrency('AUD');
                setDefaultCurrencyIcon('$');
            }
        } catch (error) {
            console.error('Error fetching user info:', error);
            // Set default values if API fails
            setUserInfo({
                user_name: 'Demo User',
                join_date: '01 Jan, 2024',
                default_currency: 'AUD',
                default_currency_icon: '$'
            });
            setDefaultCurrency('AUD');
            setDefaultCurrencyIcon('$');
        }
    };

    const get_account_detail = async (ac_name) => {
        try {
            const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
            const formData = new FormData(); 
            formData.append('user_token', systemToken); 
            formData.append('ac_name', ac_name || accountSlug); // Use dynamic account slug
            // account_name: ac_name
            const response = await fetch(`${Base_url}/customer-account`, {
                method: 'POST',
                
                body: formData
            });
            
            
            if (response.ok) {
                const data = await response.json();
                // console.log('Account detail data:', data);
                if (data.success === 200) {
                    const fumData = data.ac_info;
                    fumData.userac_establish_date = moment(fumData.userac_establish_date).format('DD MMM, YYYY');
                    // console.log('FUNDATA',fumData)
                    setFum(fumData);
                    // console.log("Subaccounts are", data.ac_data.subaccounts);
                    // Only set subac if the API returns valid data, otherwise keep the default
                    if (data.ac_data && data.ac_data.subaccounts && data.ac_data.subaccounts.length > 0) {
                        setSubac(data.ac_data.subaccounts);
                        // console.log("Subac updated from API:", data.ac_data.subaccounts);
                    } else {
                        // console.log("API returned no subaccounts, keeping default");
                    }
                    
                    // Set active subaccount
                    const subII = window.localStorage.getItem('fum_subac_id');
                    let subId = '';
                    if (subII && subII > 0) {
                        subId = subII;
                    } else {
                        subId = data.ac_data.subaccounts[data.ac_data.subaccounts.length - 1].subac_id;
                    }
                    setActiveSubac(subId);
                    // console.log("Subid is", subId);
                    // get_fum_transactions(subId);
                    
                    // Process chart data
                    // console.log('Chart data is', data.chart_data.length);
                    const chartInfo = data.chart_data;
                    if (data.chart_data.length > 0) {
                        setChart1(data.chart_data.last_month_chart);
                        setChart2(data.chart_data.three_month_chart);
                        setChart3(data.chart_data.six_month_chart);
                        setChart4(data.chart_data.year_chart.reverse());
                    }
                    
                    // Process all time chart
                    const allChart = chartInfo.all_chart;
                    // console.log('All chart is', chartInfo);
                    
                    const newChart5 = [];
                    const labels = [];
                    
                    if (chartInfo.length === 1) {
                        newChart5.push(0);
                        labels.push((allChart[0].year - 1));
                    }
                    
                    for (let i = 0; i < chartInfo.length; i++) {
                        newChart5.push(allChart[i].balance);
                        labels.push(allChart[i].year);
                    }
                    
                    setChart5(newChart5);
                    setOnChart(1);
                }
            } else {
                console.error('Account detail response not ok:', response.status, response.statusText);
                // Set default values if API fails
                setFum({
                    ac_balance: 10000,
                    default_currency_balance: 10000,
                    userac_name: 'Fund Management',
                    userac_reference_code: 'FUM001',
                    userac_establish_date: '01 Jan, 2024'
                });
                setSubac([
                     
                ]);
                setActiveSubac(1);
                setOnChart(1);
            }
        } catch (error) {
            console.error('Error fetching account detail:', error);
            console.log("Setting default values due to error");
            // Set default values if API fails
            setFum({
                ac_balance: 0,
                default_currency_balance: 0,
                userac_name: '-',
                userac_reference_code: '-',
                userac_establish_date: '-'
            });
            setSubac([
                
            ]);
            setActiveSubac(1);
            setOnChart(1);
        }
    };

    const get_fum_transactions = async (subac_id) => {
        // console.log("Subac id is", subac_id);
        if (subac_id && subac_id > 0) {
            try {
                window.localStorage.setItem('fum_fee_subac_id', subac_id);
                setActiveSubac(subac_id);
                const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
                // console.log('Getting fund management transactions from:', `${Base_url}/fum-transactions`);
                const formData =  new FormData();
                formData.append('user_token', systemToken);
                formData.append('subac_id', subac_id);
                const response = await fetch(`${Base_url}/fum-transactions`, {
                    method: 'POST',
                    body: formData
                });
                if (response.ok) {
                    const data = await response.json();
                    console.log('Fund management transactions data:', data);
                    if (data.success === 200) {
                        const transactions = data.transactions;
                        
                        // Format transaction dates
                        const formattedTransactions = transactions.map(trans => ({
                            ...trans,
                            t_time: moment(trans.trans_date).format('DD MMM, YYYY')
                        }));
                        
                        setTransactions(formattedTransactions);
                    }
                } else {
                    console.error('Fund management transactions response not ok:', response.status, response.statusText);
                    // Set default values if API fails
                    setTransactions([
                         
                    ]);
                }
            } catch (error) {
                console.error('Error fetching fund management transactions:', error);
                // Set default values if API fails
                setTransactions([
                     
                ]);
            }
        }
    };

    const get_fum_fees = async (subac_id) => {
        if (subac_id && subac_id > 0) {
            try {
                const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
                // console.log('Getting fund management fees from:', `${Base_url}/fundac-fees`);
                const formData = new FormData();
                formData.append('user_token', systemToken);
                formData.append('subac_id', subac_id);
                const response = await fetch(`${Base_url}/fundac-fees`, {
                    method: 'POST',
                    body: formData
                });
                if (response.ok) {
                    const data = await response.json();
                    console.log('Fund management fees data:', data);
                    if (data.success === 200) {
                        setFees(data.fees || []);
                    }
                } else {
                    console.error('Fund management fees response not ok:', response.status, response.statusText);
                    setFees([]);
                }
            } catch (error) {
                console.error('Error fetching fund management fees:', error);
                setFees([]);
            }
        }
    };

    // Event handlers
    const filterTrans = (event) => {
        const subac_id = event.target.value;
        console.log("Subac id is", subac_id);
        if (typeof subac_id !== "undefined" && subac_id > 0) {
            window.localStorage.setItem('fum_subac_id', subac_id);
            setActiveSubac(subac_id);
            get_fum_transactions(subac_id);
            get_fum_fees(subac_id);
        }
    };

    // Methods
    const openLink = (id) => {
        const link = document.getElementById("URL" + id).value;
        window.open(link, '_blank');
    };

    

    const getUserInfo = async () => {
        const Base_url = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
        const formData = new FormData();
        formData.append('user_token', systemToken);
        const response = await fetch(`${Base_url}/profile`, {
          method: 'POST', 
          body: formData
        });
        if (response.ok) {
            const data = await response.json();
            
            if (data.success === 200) {
              const userInf = data.profile;
              userInf.join_date = userInf.join_date ? moment(userInf.join_date).format('DD MMM, YYYY') : '';
              setUserInfo(userInf);
              setDefaultCurrency(userInf.default_currency);
              setDefaultCurrencyIcon(userInf.default_currency_icon);
            }
          } else {
            
            // Set default values if API fails
            setUserInfo({
              user_name: '',
              join_date: '',
              default_currency: 'AUD',
              default_currency_icon: '$'
            });
            setDefaultCurrency('AUD');
            setDefaultCurrencyIcon('$');
          }  
        // get_user_info(localStorageData['access-token']) // Updated reference
        //     .then(response => {
        //         if (typeof response.data !== 'undefined' && response.data.success == 200) {
        //             const userInf = response.data.profile;
        //             userInf.join_date = userInf.join_date ? moment(userInf.join_date).format('DD MMM YYYY ') : '';
        //             setUserInfo(userInf);
        //             setDefaultCurrency(userInf.default_currency);
        //             setDefaultCurrencyIcon(userInf.default_currency_icon);
        //         }
        //     }).catch(e => {
        //         console.log(e);
        //     });
    };

    const getAccountDetail = (acName) => {
        get_account_detail(localStorageData['access-token'], acName) // Updated reference
            .then(response => {
                // setSubac([]); // Commented out to prevent clearing subac data
                // if (typeof response !== 'undefined' && response.status == 200) {
                //     const fumData = response.ac_info;
                //     fumData.userac_establish_date = moment(fumData.userac_establish_date).format('DD MMM, YYYY ');
                //     setFum(fumData);

                //     const subacData = response.ac_data.subaccounts;
                //     const sData = subacData;
                    
                //     for (let i = 0; i < sData.length; i++) {
                //         // Process deposits
                //         const dData = sData[i].deposits;
                //         for (let j = 0; j < dData.length; j++) {
                //             dData[j]['t_time'] = moment.unix(dData[j]['trans_time']).utcOffset('+11').format('DD MMM YYYY | HH:mm');
                //         }
                //         sData[i].deposits = dData;

                //         // Process withdrawals
                //         const wData = sData[i].withdrawls;
                //         for (let j = 0; j < wData.length; j++) {
                //             wData[j]['t_time'] = moment.unix(wData[j]['trans_time']).utcOffset('+11').format('DD MMM YYYY | HH:mm');
                //         }
                //         sData[i].withdrawls = wData;

                //         // Process investments
                //         const iData = sData[i].investments;
                //         for (let j = 0; j < iData.length; j++) {
                //             iData[j]['t_time'] = moment.unix(iData[j]['trans_time']).utcOffset('+11').format('DD MMM YYYY | HH:mm');

                //             const tDate = iData[j].trans_date;
                //             const date = moment(tDate).utcOffset('+11').format();
                //             const date1 = moment(date).format("X");
                //             const date2 = moment().unix();

                //             const diff = Math.abs(date2 - date1);

                //             const years = Math.floor(diff / (365 * 60 * 60 * 24));
                //             const months = Math.floor((diff - years * 365 * 60 * 60 * 24) / (30 * 60 * 60 * 24));
                //             const days = Math.floor((diff - years * 365 * 60 * 60 * 24 - months * 30 * 60 * 60 * 24) / (60 * 60 * 24));

                //             iData[j]['t_days'] = days;
                //             iData[j]['t_months'] = months;
                //             iData[j]['t_years'] = years;

                //             iData[j]['investment_period'] = '';

                //             if (years > 0) {
                //                 iData[j]['investment_period'] = years + ((years > 1) ? ' yrs' : ' yr');
                //             } else if (months > 0) {
                //                 iData[j]['investment_period'] = months + ((months > 1) ? ' months' : ' month');
                //             } else {
                //                 iData[j]['investment_period'] = days + ((days > 1) ? ' days' : ' day');
                //             }

                //             iData[j]['roi'] = (sData[i].subac_currency_balance + sData[i].fund_growth + sData[i].fund_yield + sData[i].subac_currency_investment) / iData[j].trans_currency_total;
                //             iData[j]['irr'] = iData[j]['roi'] / ((years >= 1) ? years : 1);
                //         }
                //         sData[i].investments = iData;
                //     }
                    
                //     setSubac(sData);

                //     // Chart Data
                //     const chartInfo = response.data.chart_data;
                //     setChart1(chartInfo.last_month_chart);
                //     setChart2(chartInfo.three_month_chart);
                //     setChart3(chartInfo['six_month_chart']);
                //     setChart4(chartInfo['year_chart'].reverse());

                //     const newChart5 = [];
                //     const labels = [];
                //     if (chartInfo['all_chart'].length == 1) {
                //         newChart5.push(0);
                //         labels.push((chartInfo['all_chart'][0]['year'] - 1));
                //     }
                //     for (let i = 0; i < chartInfo['all_chart'].length; i++) {
                //         newChart5.push(chartInfo['all_chart'][i]['balance']);
                //         labels.push(chartInfo['all_chart'][i]['year']);
                //     }
                //     setChart5(newChart5);
                //     setOnChart(1);
                // }
            }).catch(e => {
                console.log(e);
            });
    };

    // Effects
    useEffect(() => {
        // const js = JSON.parse((localStorage.getItem(STORAGE_KEY) || "{}")); // Now this works correctly
        // if (typeof js !== 'undefined' && typeof js['access-token'] !== 'undefined') {
        //     console.log('Fund Management');
        //     setLocalStorageData(js); // Updated setter name
        // } else {
        //     localStorage.removeItem(STORAGE_KEY);
        //     navigate('/sign-in');
        // }
        
        document.title = "Fund Management || Caprock Merchant Platform";
        localStorage.setItem('active_page', 'fum');
    }, [navigate]);

    useEffect(() => {
        // if (localStorageData['access-token']) { // Updated reference
            console.log("useEffect triggered - making API calls");
            setUserName('');
            // getUserAccounts();
            // getUserInfo();
            getAccountDetail('fum');
        // } else {
        //     console.log('No token found in localStorageData');
        // }
    }, [localStorageData]); // Updated dependency

    // Debug useEffect to monitor subac state
    useEffect(() => {
        console.log('Subac state changed:', subac);
        console.log('Subac length:', subac ? subac.length : 'undefined');
    }, [subac]);

    return (
        <>
            <Basic />
            

            <div className="w-full p-5 mr-80 box-border mt-5">
                <section className="w-full">
                {/* Top Row - Account Details & Transactions */}
                <div className="flex flex-wrap gap-4 mb-6 w-full">
                    {/* Top Left - Account Details */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '33.33%' }}>
                    <div className={`bg-gradient-to-br ${accountColors.tailwindGradient} rounded-lg p-4 text-white`} style={{ minHeight: '300px' }}>
                        <div className="flex flex-wrap -mx-4">
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Account Type</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {accountSlug.charAt(0).toUpperCase() + accountSlug.slice(1).replace('-', ' ')}
                            </h5>
                        </div>
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Balance</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {defaultCurrency} {defaultCurrencyIcon} {fum.default_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </h5>
                        </div>
                        </div>
                        <div className="flex flex-wrap -mx-4 mt-3">
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Account Name</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {fum.userac_name}
                            </h5>
                        </div>
                        <div className="w-1/2 px-4 overflow-y-auto" style={{ maxHeight: '125px' }}>
                            {subac.map((subac_item) => (
                            <h5 key={subac_item.subac_id} className="text-white text-xs mt-2">
                                {subac_item.subac_name}<br />
                                {subac_item.currency_name} {subac_item.currency_symbol}{subac_item.subac_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </h5>
                            ))}
                        </div>
                        </div>
                        <div className="flex flex-wrap -mx-4 mt-3">
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Account Reference</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            #{fum.userac_reference_code}
                            </h5>
                        </div>
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Date Account Established</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {fum.userac_establish_date}
                            </h5>
                        </div>
                        </div>
                    </div>
                    </div>

                    {/* Top Right - Transactions & Fees */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '66.67%' }}>
                    <div className="bg-white rounded-lg shadow-lg" style={{ minHeight: '300px' }}>
                        {/* Tab Navigation */}
                        <div className="flex border-b border-gray-200 bg-white" style={{ borderRadius: '10px 10px 0px 0px' }}>
                            <div className="flex justify-start items-center py-4 pl-6">
                                <button
                                    onClick={() => setActiveTab('transactions')}
                                    className={`mx-2 cursor-pointer font-bold ${
                                        activeTab === 'transactions'
                                            ? 'text-orange-500'
                                            : 'text-gray-500'
                                    }`}
                                >
                                    Transactions
                                </button>
                                <span className="mx-2 text-gray-500">|</span>
                                <button
                                    onClick={() => {
                                        setActiveTab('fees');
                                        if (activeSubac && activeSubac > 0) {
                                            get_fum_fees(activeSubac);
                                        }
                                    }}
                                    className={`mx-2 cursor-pointer font-bold ${
                                        activeTab === 'fees'
                                            ? 'text-orange-500'
                                            : 'text-gray-500'
                                    }`}
                                >
                                    Fees
                                </button>
                            </div>
                        </div>

                        {/* Transactions Tab Content */}
                        {activeTab === 'transactions' && (
                            <div className="px-3">
                                {/* All Subaccounts Listed */}
                                {subac.length > 0 && subac.map((currentSubac, subacIndex) => (
                                    <div key={currentSubac.subac_id} className={`px-1 py-3 border-b border-gray-200`}>
                                        {/* Subaccount Header */}
                                        <div className="flex items-center justify-between mb-0">
                                            <p className="text-xs text-gray-600 m-0 flex items-center">
                                                <button className="bg-black text-white px-2 py-0.5 text-xs uppercase mr-1 rounded-full">
                                                    {currentSubac.currency_name}
                                                </button>
                                                {currentSubac.subac_name}
                                            </p>
                                            <p className="text-base m-0 text-gray-600">|</p>
                                            <p className="text-xs text-gray-600 m-0">
                                                Not Invested <span className="text-green-600">{currentSubac.currency_symbol} {currentSubac.not_invested?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</span>
                                            </p>
                                            <p className="text-base m-0 text-gray-600">|</p>
                                            <p className="text-xs text-gray-600 m-0">
                                                Growth <span>{currentSubac.currency_symbol}{currentSubac.growth?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</span>
                                            </p>
                                            <p className="text-base m-0 text-gray-600">|</p>
                                            <p className="text-xs text-gray-600 m-0">
                                                Yield <span>{currentSubac.currency_symbol}{currentSubac.fund_yield?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</span>
                                            </p>
                                            <p className="text-base m-0 text-gray-600">|</p>
                                            <p className="text-xs text-gray-600 m-0">
                                                Return <span>{currentSubac.currency_symbol}{currentSubac.return?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</span>
                                            </p>
                                        </div>

                                        {/* Column Headers */}
                                        <div className="grid grid-cols-3 px-3 mt-3">
                                            <div className="flex items-center pl-2">
                                                <p className="text-gray-500 text-base m-0 font-semibold">Deposit</p>
                                            </div>
                                            <div className="flex items-center pl-2">
                                                <p className="text-gray-500 text-base m-0 font-semibold">Withdrawal</p>
                                            </div>
                                            <div className="flex items-center pl-2">
                                                <p className="text-gray-500 text-base m-0 font-semibold">Investment</p>
                                            </div>
                                        </div>

                                        {/* Three Column Layout for this subaccount */}
                                        <div className="grid grid-cols-3 mt-2">
                                            {/* Deposit Column */}
                                            <div className="border-r border-gray-200 px-1 overflow-y-auto" style={{ maxHeight: '230px' }}>
                                                <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                    Balance {currentSubac.currency_symbol}{currentSubac.subac_currency_balance?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                </div>
                                                <div className="text-gray-600 text-sm p-1 border-b border-gray-200 mb-4">
                                                    Fund Valuation {currentSubac.currency_symbol}{currentSubac.subac_currency_balance?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                </div>
                                                {currentSubac.deposits && currentSubac.deposits.map((deposit, index) => (
                                                    <div key={index}>
                                                        <div className="text-gray-600 border-b border-gray-200 text-base p-1 flex items-center">
                                                            <button className="bg-black text-white px-2 py-0.5 text-xs uppercase rounded-full">
                                                                {deposit.currency_name}
                                                            </button>
                                                            <p className="text-gray-600 text-sm m-0 ml-2">
                                                                {deposit.currency_symbol}{deposit.trans_amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                                <small className="text-gray-600"> ( {deposit.currency_symbol} {deposit.trans_currency_total?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'} rate {deposit.trans_currency_rate?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '1.00'}) </small>
                                                            </p>
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            {moment.unix(deposit.trans_time).format('DD MMM YYYY | HH:mm')}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Ref#{deposit.trans_reference_no}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            {deposit.trans_description}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Withdrawal Column */}
                                            <div className="border-r border-gray-200 px-1 overflow-y-auto" style={{ maxHeight: '230px' }}>
                                                {currentSubac.withdrawls && currentSubac.withdrawls.map((withdrawal, index) => (
                                                    <div key={index}>
                                                        <div className="text-gray-600 border-b border-gray-200 text-base p-1 flex items-center">
                                                            <button className="bg-black text-white px-2 py-0.5 text-xs uppercase rounded-full">
                                                                {withdrawal.currency_name}
                                                            </button>
                                                            <p className="text-gray-600 text-sm m-0 ml-2">
                                                                <span className="font-bold text-red-500">-</span> {withdrawal.currency_symbol}{withdrawal.trans_amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                                <small className="text-gray-600"> ( {withdrawal.currency_symbol} {withdrawal.trans_currency_total?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'} rate {withdrawal.trans_currency_rate?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '1.00'}) </small>
                                                            </p>
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            {withdrawal.trans_description}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            {moment.unix(withdrawal.trans_time).format('DD MMM YYYY | HH:mm')}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Ref#{withdrawal.trans_reference_no}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Investment Column */}
                                            <div className="px-1 overflow-y-auto" style={{ maxHeight: '230px' }}>
                                                {currentSubac.investments && currentSubac.investments.map((investment, index) => (
                                                    <div key={index}>
                                                        <div className="text-gray-600 border-b border-gray-200 text-base p-1 flex items-center">
                                                            <button className="bg-black text-white px-2 py-0.5 text-xs uppercase rounded-full">
                                                                {investment.currency_name}
                                                            </button>
                                                            <p className="text-gray-600 text-sm m-0 ml-2">
                                                                {investment.currency_symbol}{investment.trans_amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                                <small className="text-gray-600"> ( {investment.currency_symbol} {investment.trans_currency_total?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'} rate {investment.trans_currency_rate?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '1.00'}) </small>
                                                            </p>
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            {investment.trans_description}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            {moment.unix(investment.trans_time).format('DD MMM YYYY | HH:mm')}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Ref#{investment.trans_reference_no}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Investment period 0 day
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Fees Tab Content */}
                        {activeTab === 'fees' && (
                            <div className="px-3">
                                {/* Fees Header with Dropdown */}
                                <div className="px-1 py-3 border-b border-gray-200">
                                    <div className="flex items-center justify-between">
                                        <h3 className="text-base font-medium text-gray-500">Fees</h3>
                                        <select 
                                            className="bg-gray-50 border border-gray-300 text-black rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                            value={activeSubac}
                                            onChange={filterTrans}
                                        >
                                            <option key="sj" value={0} className="text-gray-900">SELECT SUB ACCOUNT</option>
                                            {subac.map((subac_item) => (
                                                <option
                                                    key={subac_item.subac_id} 
                                                    value={subac_item.subac_id}
                                                    className="text-gray-900"
                                                >
                                                    {subac_item.subac_name} ({subac_item.currency_name})
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Fees Table */}
                                <div className="px-1 py-3">
                                    <div className="bg-white rounded-lg overflow-hidden">
                                        <table className="w-full">
                                            <thead className="bg-gray-50">
                                                <tr>
                                                    <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Month</th>
                                                    <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Highest Balance</th>
                                                    <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Fee</th>
                                                    <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">GST</th>
                                                    <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Fee Amount (Inc. GST)</th>
                                                    <th className="px-2 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Paid Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {fees.length > 0 ? (
                                                    fees.map((fee, index) => (
                                                        <tr key={index}>
                                                            <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {moment(fee.fee_date).format('DD MMM, YYYY')}
                                                            </td>
                                                            <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {fee.fee_highest_fund_ac_balance?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                            </td>
                                                            <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {fee.fee_percent || 0} %
                                                            </td>
                                                            <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {fee.fee_gst || 0} %
                                                            </td>
                                                            <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {fee.fee_inc_gst_amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                            </td>
                                                            <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                                                                {fee.fee_paid_amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="px-4 py-8 text-center text-sm text-gray-500">
                                                            No fees data available
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    </div>
                </div>

                {/* Bottom Row - Portfolio and Chart */}
                <div className="flex flex-wrap gap-4 w-full">
                    {/* Bottom Left - Portfolio */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '33.33%' }}>
                     
                    </div>

                    {/* Bottom Right - Chart */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '66.67%' }}>
                    <div className="bg-white rounded-xl overflow-hidden h-full">
                        {/* Chart Navigation */}
                        <div className="border-b border-gray-200 px-6 py-4">
                        <div className="flex space-x-8">
                            <button 
                            onClick={() => setActiveChart(1)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 1 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            Last Month
                            </button>
                            <button 
                            onClick={() => setActiveChart(2)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 2 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            3M
                            </button>
                            <button 
                            onClick={() => setActiveChart(3)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 3 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            6M
                            </button>
                            <button 
                            onClick={() => setActiveChart(4)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 4 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            Year
                            </button>
                            <button 
                            onClick={() => setActiveChart(5)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 5 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            All
                            </button>
                        </div>
                        </div>

                        {/* Chart Content */}
                        <div className="p-6">
                        {onChart === 1 ? (
                            <div className="h-70 flex items-center justify-center">
                                {activeChart === 1 && <Line data={{ labels: ["Week 1", "Week 2", "Week 3", "Week 4"], datasets: [{ label: 'Balance', data: chart1, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions1} />}
                                {activeChart === 2 && <Line data={{ labels: ["Month 1", "Month 2", "Month 3"], datasets: [{ label: 'Balance', data: chart2, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions2} />}
                                {activeChart === 3 && <Line data={{ labels: ["Month 1", "Month 2", "Month 3", "Month 4", "Month 5", "Month 6"], datasets: [{ label: 'Balance', data: chart3, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions3} />}
                                {activeChart === 4 && <Line data={{ labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], datasets: [{ label: 'Balance', data: chart4, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions4} />}
                                {activeChart === 5 && <Line data={{ labels: ["Year 1", "Year 2"], datasets: [{ label: 'Balance', data: chart5, borderColor: '#494949', backgroundColor: 'rgba(73, 73, 73, 0.5)' }] }} options={chartOptions5} />}      
                        
                            </div>
                        ) : (
                            <div className="h-64 flex items-center justify-center bg-gray-50 rounded border-2 border-dashed border-gray-300">
                            <span className="text-gray-500">Loading...</span>
                            </div>
                        )}
                        </div>
                    </div>
                    </div>
                </div>
                </section>
            </div>
        </>
    );
};

export default Fum;
